import React, { useEffect, useState } from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ListaProducto from "../../../components/products/ListaProducto";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadIcon from "@mui/icons-material/Download";
import useProduct from "../../../hooks/useProduct";
import SideBarProducts from "../../../components/pgi/SidebarProducts";
import CarouselMobile from "../../../components/carousel/CarouselMobile";
import usePgiModules from "../../../hooks/useModules";
import BannerPub from "../../../components/BannerPub";
import FaqsDinamic from "../../../components/faqs/FaqsDinamic";
import useNews from "../../../hooks/useNews";
import CardNews from "../../../components/news/CardNews";
import ModuleBlockNews from "../../../components/news/ModuleBlockNews";
import toast from "react-hot-toast";
import { getNewsByProduct } from "../../../helpers/constants";
import { PRODUCTO_ESPECIAL, PRODUCTO_LINEA } from "../../../helpers/constants";
import { sortAndFilterProducts } from "../../../helpers/functions";

const ProductsReplicaPgi = ({ titleProduct, idProduct }) => {
  const { getProductsByBody, product, products, getAllProducts } = useProduct();
  const [lowerTitle, setLowerTitle] = useState("");
  const [homeModules, setHomeModules] = useState([]);
  const { loading, setLoading } = useState(true);
  const { getModulesByParams } = usePgiModules();
  const [news, setNews] = useState([]);
  const { obtenerNoticias } = useNews();
  let descargasVisibles;

  useEffect(() => {
    const getProductsNews = async () => {
      try {
        const data = await obtenerNoticias(...getNewsByProduct(product?.title));
        setNews(data.allNews);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error('Error al obtener las noticias multimedia')
      }
    };
    getProductsNews();
  }, [product]);

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });
    getAllProducts({ onlyTitleAndIcon: true, visible: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getProductsByBody({ title: titleProduct, _id: idProduct });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  useEffect(() => {
    getProductsByBody({ title: titleProduct, _id: idProduct });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleProduct]);

  useEffect(() => {
    const newTitle = encodeURI(titleProduct?.replaceAll(" ", "-")).toLowerCase();
    setLowerTitle(newTitle);
  }, [titleProduct]);

  descargasVisibles = product.filename?.filter(
    (item) => item.state === true && item.deleted !== true
  );

  const newsProduct = news?.filter(
    (noticia) =>
      noticia?.product === product?.title &&
      noticia?.deleted === false &&
      noticia?.visible === true &&
      noticia?.publish === true
  );

  return !loading ? (
    <>
      {product.type === "productoLinea" ? (
        <>
          <div id="blur-prueba">
            {/* SOLO PARA MAQUETA */}
            <div>
              <section className="contenedor-principal">
                <div id="maqueta" className="bg-fullpage">
                  <picture className="bg-fullpage bg_products">
                    <img
                      src={product.imageBackground ? product.imageBackground[0]?.url : ""}
                      alt="Imagen-blockes"
                    />
                  </picture>
                </div>

                <div className="botton-editar-pginews">
                  <SideBarProducts replicaPgi={true} />
                  <button className=" settings_button-pleno overlay-replica-button">
                    <a href="/pgi/edit-productos">Editar producto</a>
                  </button>
                </div>
                <div className="container" id="info">
                  <div className="intro-prod">
                    <article className="info-slider margin_posicion col-lg-6 col-sm-12">
                      <header className="stiker-card">
                        <h1>{product?.title}</h1>
                      </header>
                      <img
                        itemProp="logo"
                        src={product.imageLogo ? product.imageLogo[0]?.url : product.imageLogo}
                        alt=""
                        className="info-logo"
                      />
                      <p>{product?.top}</p>
                    </article>
                  </div>
                  {/* </div> */}
                </div>
              </section>
            </div>

            {product.type !== undefined && product.type === "productoEspecial" ? (
              <>
                <section id="bloq-inferior" className="container pt-5">
                  <ul className="check-list ">
                    {product?.benefit?.map((item, index) => (
                      <li key={index} className="col-10 col-lg-6 col-md-6">
                        <span className="material-icons-outlined">
                          {item.iconBenefit ? item.iconBenefit : "check_box"}
                        </span>{" "}
                        {item.textBenefit}
                      </li>
                    ))}
                  </ul>
                </section>
              </>
            ) : (
              <>
                <section id="bloq-inferior" className="container">
                  <ul className="check-list ">
                    {product?.benefit?.map((item, index) => (
                      <li key={index} className="col-10 col-lg-6 col-md-6">
                        <span className="material-icons-outlined">
                          {item.iconBenefit ? item.iconBenefit : "check_box"}
                        </span>{" "}
                        {item.textBenefit}
                      </li>
                    ))}
                  </ul>
                </section>
              </>
            )}

            {/* Ilustraciones de colocado  */}

            <section className="bg-break">
              <div className="container img-instal">
                <img
                  src={product.imageProduct ? product.imageProduct[0]?.url : ""}
                  alt="Ilustración de instalación "
                  className="foto-instal"
                />
                <img
                  src={product?.imageProduct ? product?.imageProduct[1]?.url : ""}
                  alt="Ilustración de instalación"
                  className="img-block col-6"
                />
              </div>

              {/* TEXTO Y BOTONES */}

              <div className="container text-button">
                <article className="info-text col-12 col-md-12 col-lg-9 mb-4 pb-4">
                  <h3 className="padding_top">{product?.titleSubDescription}</h3>
                  <p
                    className="product-tiny-editor"
                    dangerouslySetInnerHTML={{
                      __html: product?.subdescription
                    }}
                  ></p>
                </article>
                <div role="presentation" className="settings__col-buttons col-3 columna-3">
                  <div className={`width-50 ${descargasVisibles?.length === 0 ? "d-none" : ""}`}>
                    <h3>Descargas</h3>
                    <ul className="settings__lista-descargas">
                      {product?.filename?.map(
                        (item, index) =>
                          item.state === true &&
                          item.deleted === false && (
                            <li key={index}>
                              <DownloadIcon />
                              <a
                                href={item?.url}
                                Target="_blank"
                                title={`Descargar ${item.filename}`}
                              >
                                {item?.title}
                              </a>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                  <div className="width-50">
                    <button
                      className={`settings_button-pleno bg-p-primary_2 ${
                        product.instalationStepsEnabled && product.instalationSteps?.length !== 0
                          ? ""
                          : "d-none"
                      }`}
                    >
                      <a href={`/instalacion/${lowerTitle}`} title={`Instalación de ${lowerTitle}`}>
                        Instalación <ArrowForwardIcon />
                      </a>
                    </button>
                    {product.faqs?.length !== 0 && product.faqsEnabled && (
                      <FaqsDinamic vistaProducto={true} producto={product} />
                    )}
                    <button className="settings_button-border button-b-primary_2">
                      <a href="/donde-comprar" title={`Dónde comprar ${product.title}`}>
                        DONDE COMPRAR <ArrowForwardIcon />
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {homeModules.map((item, index) => {
            switch (item.title) {
              case "Banner_publicitario":
                if (item.visible.includes(`${product._id}`)) {
                  return (
                    <>
                      <BannerPub key={index} idProducto={product._id} />
                    </>
                  );
                }
                break;
              case "Bloque_info":
                if (item.visible.includes("home")) {
                  return <ModuleBlockNews key={index} editPgi={true} idProducto={product._id} />;
                }
                break;
              default:
            }
          })}
          {product.subproduct
            ? product.subproduct.length !== 0 && (
                <div>
                  <ListaProducto subProducts={product?.subproduct} />
                </div>
              )
            : ""}
          {homeModules.map((item, index) => {
            switch (item.title) {
              case "Carrousel_deLinea":
                if (item.visible.includes(`${product._id}`)) {
                  return (
                    <div key={index} className="container producto-linea">
                      <CarouselMobile products={sortAndFilterProducts(products, PRODUCTO_LINEA)}/>
                    </div>
                  );
                }
                break;
              case "Carrousel_especial":
                if (item.visible.includes(`${product._id}`)) {
                  return (
                    <div key={index} className="container producto-linea">
                      <CarouselMobile isHomePage isProductoEspecial products={sortAndFilterProducts(products, PRODUCTO_ESPECIAL)}/>
                    </div>
                  );
                }
                break;
              default:
            }
          })}
          {newsProduct?.length > 0 && (
            <>
              <div className="container">
                <div className="seccion-mas-noticias">
                  <div className="title-noticias ">
                    <h3>Últimas noticias de {product.title}</h3>
                  </div>
                </div>
                <div className="seccion-cards-noticias ">
                  <div id="seccion-noticas">
                    <div className="">
                      <div className="masonry mansory_tensoblog_replica">
                        {loading ? (
                          <>
                            <CardNews loading={true} tensoblog={true} />
                            <CardNews loading={true} tensoblog={true} />
                          </>
                        ) : (
                          <>
                            {newsProduct?.map((noticia, index) => (
                              <CardNews key={index} noticia={noticia} />
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div id="blur-prueba">
            <div className="botton-editar-pginews">
              <SideBarProducts replicaPgi={true} />
              <button className=" settings_button-pleno overlay-replica-button">
                <a href="/pgi/edit-productos">Editar producto</a>
              </button>
            </div>
            <div id="maqueta" className="bg-fullpage">
              <img
                className="imagen-prod"
                src={product.imageBackground ? product.imageBackground[0]?.url : ""}
                alt="Imagen blockes"
              />
              <div className="container info-pgi-product-especial" id="info-products">
                <article className="info-slider col-lg-6 col-sm-12">
                  <header className="stiker-card">
                    <h1>{product.title}</h1>
                  </header>
                  <p className="parrafo-info-products mt-4">{product.top}</p>
                  {product?.filename?.map(
                    (item, index) =>
                      item.state === true &&
                      item.deleted === false && (
                        <a
                          key={index}
                          href={item?.url}
                          Target="_blank"
                          title={`Descargar ${item.filename}`}
                          className="ficha-tecnica-button text-center"
                        >
                          {item?.title} <ArrowDownwardIcon />
                        </a>
                      )
                  )}
                </article>
              </div>
            </div>
            <section className="container benefits">
              <ul className="check-list ">
                {product?.benefit?.map((item, index) => (
                  <li key={index} className="col-10 col-lg-6 col-md-6">
                    <span className="material-icons-outlined">
                      {item.iconBenefit ? item.iconBenefit : "check_box"}
                    </span>{" "}
                    {item.textBenefit}
                  </li>
                ))}
              </ul>
            </section>
            {/* {product.titleSubDescription && ( */}
            <section className="bg-grey">
              <div className="container text-button">
                <article className="info-text col-12 col-md-12 col-lg-9 pb-4">
                  <h3 className="padding_top text-center mb-3">{product?.titleSubDescription}</h3>
                  <p
                    className="product-tiny-editor"
                    dangerouslySetInnerHTML={{
                      __html: product?.subdescription
                    }}
                  ></p>
                </article>
                <div role="presentation" className="settings__col-buttons col-3 columna-3">
                  <div className={`width-50 ${descargasVisibles?.length === 0 ? "d-none" : ""}`}>
                    <h3>Descargas</h3>
                    <ul className="settings__lista-descargas">
                      {product?.filename?.map(
                        (item, index) =>
                          item.state === true &&
                          item.deleted === false && (
                            <li key={index}>
                              <DownloadIcon />
                              <a
                                href={item?.url}
                                Target="_blank"
                                title={`Descargar ${item.filename}`}
                              >
                                {item?.title}
                              </a>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                  <div className="width-50">
                    {product.faqs?.length !== 0 && product.faqsEnabled && (
                      <FaqsDinamic vistaProducto={true} producto={product} />
                    )}
                    <button className="settings_button-border button-b-primary_2">
                      <a href="/contacto" title={`Dónde comprar ${product.title}`}>
                        Consulta técnica <ArrowForwardIcon />
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </section>
            {/* )} */}

            {homeModules.map((item, index) => {
              switch (item.title) {
                case "Banner_publicitario":
                  if (item.visible.includes(`${product._id}`)) {
                    return (
                      <>
                        <BannerPub key={index} idProducto={product._id} />
                      </>
                    );
                  }
                  break;
                default:
              }
            })}
            {homeModules.map((item, index) => {
              switch (item.title) {
                case "Carrousel_deLinea":
                  if (item.visible.includes(`${product._id}`)) {
                    return (
                      <div key={index} className="container producto-linea">
                        <CarouselMobile products={sortAndFilterProducts(products, PRODUCTO_LINEA)}/>
                      </div>
                    );
                  }
                  break;
                case "Carrousel_especial":
                  if (item.visible.includes(`${product._id}`)) {
                    return (
                      <div key={index} className="container producto-linea">
                        <CarouselMobile isProductoEspecial products={sortAndFilterProducts(products, PRODUCTO_ESPECIAL)}/>
                      </div>
                    );
                  }
                  break;
                default:
              }
            })}
            {newsProduct?.length > 0 && (
              <>
                <div className="container">
                  <div className="seccion-mas-noticias">
                    <div className="title-noticias ">
                      <h3>Últimas noticias de {product.title}</h3>
                    </div>
                  </div>
                  <div className="seccion-cards-noticias ">
                    <div id="seccion-noticas">
                      <div className="">
                        <div className="masonry mansory_tensoblog_replica">
                          {loading ? (
                            <>
                              <CardNews loading={true} tensoblog={true} />
                              <CardNews loading={true} tensoblog={true} />
                            </>
                          ) : (
                            <>
                              {newsProduct?.map((noticia, index) => (
                                <CardNews key={index} noticia={noticia} />
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  ) : (
    "Loading"
  );
};

export default ProductsReplicaPgi;
